/** This slice is for data used commonly in nearly ever component of our application */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isPrimaryKeyValid: true,
};

export const tempSlice = createSlice({
	name: 'temp',
	initialState: initialState,
	reducers: {
		setIsPrimaryKeyValid: (state, action) => {
			state.isPrimaryKeyValid = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setIsPrimaryKeyValid } = tempSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectIsPrimaryKeyValid = (state) => state.temp.isPrimaryKeyValid;

export default tempSlice.reducer;
